export default __webpack_public_path__ + "static/media/github.cf982205.PNG";